import React from 'react';
import SectionTitle from "../../Common/SectionTitle";
import SingleFeature from "../SingleFeature";
import { Feature } from "@/types/feature";

const FeaturesDesktop = ({ 
  title, 
  paragraph, 
  featuresData 
}: { 
  title: string;
  paragraph: string;
  featuresData: Feature[];
}) => {
  return (
    <div className="container">
      <SectionTitle
        title={title}
        paragraph={paragraph}
        center
      />

      <div className="grid grid-cols-3 gap-x-8 gap-y-14 justify-items-center">
        {featuresData.map((feature, index) => (
          <SingleFeature key={`${feature.id}-${index}`} feature={feature} />
        ))}
      </div>
    </div>
  );
};

export default FeaturesDesktop; 